module.exports = __webpack_public_path__ + "static/media/Life.0accdea9.svg";